import { render } from "./apiDetail.vue?vue&type=template&id=b0dd5414&scoped=true"
import script from "./apiDetail.vue?vue&type=script&lang=js"
export * from "./apiDetail.vue?vue&type=script&lang=js"

import "./apiDetail.vue?vue&type=style&index=0&id=b0dd5414&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0dd5414"]])

export default __exports__